<template>
  <div class="container box" id="container-main">
    <div class="row" id="main-row">
      <div class="header">
        <h1 class="title">Flows</h1>
        <div class="buttonsGroup">
          <b-tooltip label="Add a Flow" position="is-bottom"
            ><button class="button is-medium is-info" @click="isNewItemActive = true">
              <b-icon icon="plus" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Edit a Flow" position="is-bottom"
            ><button class="button is-medium is-info" @click="EditItem()">
              <b-icon icon="pencil" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Duplicate a Flow" position="is-bottom"
            ><button class="button is-medium is-info" @click="DuplicateItem()">
              <b-icon icon="copy" size="is-small"></b-icon></button
          ></b-tooltip>
          <b-tooltip label="Delete a Flow" position="is-left"
            ><button class="button is-medium is-danger" @click="DeleteItem()">
              <b-icon icon="trash" size="is-small"></b-icon></button
          ></b-tooltip>
        </div>
      </div>
      <template>
        <b-table :data="this.flows" :selected.sync="selected" hoverable :loading="this.loading">
          <b-table-column field="flow_name" label="Name" sortable v-slot="props">
            {{ props.row.flow_name }}
          </b-table-column>
          <b-table-column field="flow_description" label="Description" sortable v-slot="props">
            {{ props.row.flow_description }}
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                </p>
                <p>Looks like there aren't any Flows</p>
              </div>
            </section>
          </template>
        </b-table>
        <b-modal :active.sync="isNewItemActive" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog" aria-modal>
          <new-item @submitted="AddNewItem" :heading="'New flow'" :selected="this.formProps"></new-item>
        </b-modal>
        <b-modal :active.sync="isDuplicateItemActive" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog" aria-modal>
          <new-item @submitted="SubmitDuplicate" :heading="'Duplicate flow'" :selected="this.formProps"></new-item>
        </b-modal>
        <b-modal :active.sync="isImportItemActive" has-modal-card trap-focus :destroy-on-hide="true" aria-role="dialog" aria-modal>
          <import-item @submitted="SubmitImport" :heading="'Import Flow'" :file="this.importFile"></import-item>
        </b-modal>
      </template>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
const NewItem = {
  props: {
    selected: {
      type: Object,
      required: false,
    },
    heading: {
      type: String,
      required: true,
    },
  },
  methods: {
    submit: function () {
      this.$emit("submitted");
    },
  },
  template: `
        <form action="#" v-on:submit.prevent="submit">
                <div class="modal-card" style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ heading }}</p>
                    </header>
                    <section class="modal-card-body">

                        <b-field label="Name">
                            <b-input
                                type="text"
                                placeholder="e.g. Main Flow"
                                v-model="selected.flow_name"
                                required>
                            </b-input>
                        </b-field>

                        <b-field label="Description">
                            <b-input
                                type="text"
                                placeholder="e.g. Fixed location flow"
                                v-model="selected.flow_description">
                            </b-input>
                        </b-field>
                    </section>
                    <footer class="modal-card-foot">
                        <button class="button" type="button" @click="$parent.close()">Cancel</button>
                        <button class="button is-primary" type="submit">Submit</button>
                    </footer>
                </div>
            </form>
        `,
};

const ImportItem = {
  props: {
    heading: {
      type: String,
      required: true,
    },
    file: {
      required: true,
    },
  },
  methods: {
    submit: function () {
      this.$emit("submitted", this.file);
    },
  },
  template: `
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ heading }}</p>
            </header>
            <section class="modal-card-body">
              <b-upload v-model="file" drag-drop expanded>
                <section class="section">
                  <div class="content has-text-centered">
                    <p>
                      <b-icon icon="upload" size="is-large"></b-icon>
                    </p>
                    <p>Drop the flow file here or click to upload</p>
                  </div>
                </section>
              </b-upload>
              <div class="tags">
                <span v-if="file.name.length > 2" class="file-name">
                  {{file.name}}
                </span>
              </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Cancel</button>
                <button v-if="file.name.length > 2" class="button is-primary" type="submit" @click="submit()">Submit</button>
            </footer>
        </div>
      `,
};

const urlParams = new URLSearchParams(window.location.search);
const error = urlParams.get("error");

export default {
  components: {
    NewItem,
    ImportItem,
  },
  data: function () {
    return {
      display: "redbox",
      flows: [],
      selected: {},
      isNewItemActive: false,
      isDuplicateItemActive: false,
      formProps: {},
      isImportItemActive: false,
      importFile: new File([], ""),
      newApiUrl: "https://api.jeak.co.uk",
      loading: true,
    };
  },
  methods: {
    AddNewItem: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios
        .post(this.newApiUrl + `/flows`, this.formProps, config)
        .then((response) => {
          this.isNewItemActive = false;
          this.$buefy.toast.open({
            message: "Flow Successfully Added!",
            type: "is-success",
          });
          this.GetItems();
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
        });
    },
    EditItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to edit first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        window.location.href = `floweditor?flowid=${this.selected.flow_id}`;
      }
    },
    DuplicateItem: function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to duplicate first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        this.isDuplicateItemActive = true;
      }
    },
    SubmitDuplicate: async function () {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios
        .post(this.newApiUrl + `/flows/${this.selected.flow_id}/duplicate`, this.formProps, config)
        .then((response) => {
          this.isDuplicateItemActive = false;
          this.GetItems();
        })
        .catch((error) => {
          this.$buefy.snackbar.open({
            message: "An error occurred! If this persists, please contact support",
            type: "is-danger",
            position: "is-top",
          });
        });
    },
    ExportItem: async function () {
      if (Object.entries(this.selected).length === 0) {
        this.$buefy.snackbar.open({
          message: "Please select an item to export first!",
          type: "is-warning",
          position: "is-top",
        });
      } else {
        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios
          .get(this.newApiUrl + `/flows/${this.selected.flow_id}/export`, config)
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            let disposition = response.headers["content-disposition"];
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            fileLink.setAttribute("download", filename);
            document.body.appendChild(fileLink);

            fileLink.click();
          })
          .catch((error) => {
            console.log(error);
            this.$buefy.snackbar.open({
              message: "An error has occurred! If this persists, please contact support",
              type: "is-danger",
              position: "is-top",
            });
          });
      }
    },
    SubmitImport(file) {
      this.importFile = file;
      let fileReader = new FileReader();
      fileReader.onload = async (event) => {
        let body = {
          file: event.target.result,
        };

        const token = await this.$cognitoAuth.getIdToken();
        const config = {
          headers: { Authorization: `Bearer ` + token },
        };
        axios.post(this.apiUrl + `/flows/import`, body, config).catch((error) => {
          console.log(error);
        });
      };
      fileReader.readAsText(this.importFile, "UTF-8");
    },
    DeleteItem: function (flowId) {
      this.$buefy.dialog.confirm({
        title: "Deleting flow",
        message: "Are you sure you want to <b>delete</b> this flow? This action cannot be undone.",
        confirmText: "Delete Flow",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.$buefy.toast.open({
            message: "Flow Successfully Deleted!",
            type: "is-success",
          });
          const token = await this.$cognitoAuth.getIdToken();
          const config = {
            headers: { Authorization: `Bearer ` + token },
          };
          axios.delete(this.newApiUrl + "/flows/" + this.selected.flow_id, config).then((response) => {
            this.GetItems();
          });
        },
      });
    },
    GetItems: async function () {
      this.loading = true;
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ` + token },
      };
      axios.get(this.newApiUrl + "/flows", config).then((response) => {
        this.flows = response.data;
        this.loading = false;
      });
    },
  },
  async mounted() {
    if (error == "locked") {
      this.$buefy.toast.open({
        message: "This flow is currently being edited by another session!",
        type: "is-danger",
      });
    }
    this.GetItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  margin-top: 20px;
}
#vapp {
  display: grid;
  grid-template-rows: 1fr;
}
.header {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
}
.header h1 {
  grid-column: 1/6;
}
.buttonsGroup {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
.b-table {
  height: 100%;
  max-height: 650px;
}
</style>
